export default __webpack_public_path__ + "static/media/dispatch riders icon.93dab7c9.svg";